<p-dialog header="Carte"
          dismissableMask="true"
          modal="true"
          position="200 200 200 200"
          [draggable]="false"  
          [resizable]="false"> 

    <div *ngFor="let drom of dromLayers">
        <input name="selectionTerritoire" type="radio" (click)="goToDrom(drom)" [checked]="drom.title">{{drom.title}}
    </div>
</p-dialog>

<p-dialog header="Couches"
        dismissableMask="true"
        modal="true"
        position="10 10 10 10"
        [draggable]="false"  
        [resizable]="false"> 

        <div *ngFor="let layer of layerSwitcherLayers">
            <input type="checkbox" (change)="toggleLayer(layer)" [(ngModel)]="layer.visible" [id]="layer.id">{{layer.title}}
        </div>
</p-dialog>

<div id="map" class="map">
    <div id="search" class="row searchAddress">
        <span class="p-input-icon-right" >
            <i class="pi pi-search" style="margin-left: 0%; font-size: 20px; color: blue" (click)="findByAddress()"></i>
            <input type="text" 
                   pInputText 
                   class="champ-recherche-adresse"
                   [(ngModel)]="address" 
                   (keyup.enter)="findByAddress()" />
        </span>
    </div>

    <div id="couches" class="row couches">
        <p-button type="button"(click)="panelCouches.toggle($event)"  class="bouton-carte">
            <img src="assets/images/icone-couche.svg">
        </p-button>
        <p-overlayPanel #panelCouches>
            <div *ngFor="let layer of layerSwitcherLayers">
                <input type="checkbox" (change)="toggleLayer(layer)" [(ngModel)]="layer.visible" [id]="layer.id">{{layer.title}}
            </div>
        </p-overlayPanel>
    </div>

    <div id="territoires" class="row territoires">
        <p-button type="button" (onClick)="panelTerritoires.toggle($event)" class="bouton-carte">
            <img src="assets/images/icone-carte.svg">
        </p-button>
        <p-overlayPanel #panelTerritoires>
            <div *ngFor="let drom of dromLayers">
                <input name="selectionTerritoire" type="radio" (click)="goToTerritoires(drom)" [checked]="drom.title">{{drom.title}}
            </div>
        </p-overlayPanel>
    </div>
</div>
